import logo from './logo.svg';
import { BrowserRouter , Route , Routes} from 'react-router-dom';
import Home from './components/Home/home';
import Navbar from './components/Navbar/Navbar';
import Skills from './components/Skills/skills';
import Portfolio from './components/Portfolio/portfolio';
import { Element } from 'react-scroll';
import Achievements from './components/Achievements/achievements';
import { useMediaQuery } from '@mui/material';
import Github from './components/codingProfiles/github';
import Leetcode from './components/codingProfiles/leetcode';
function App() {
  const isNonMobileScreen = useMediaQuery("(min-width:1000px)");
  return (
    <div>
      {isNonMobileScreen && <Navbar/>}
      <div id="home">
        <Home/>
      </div>
      <div id='skills'>
        <Skills/>
      </div>
      <div id='portfolio'>
        <Portfolio/>
      </div>
      <div id='achievements'>
        <Achievements/>
      </div>
    </div>
  );
}

export default App;
